import Grid from '@mui/material/Grid';
import { PhotoEvent } from 'common-models';
import { FC } from 'react';
import { EventLink } from './EventLink';

const EventsList: FC<{ events: Array<PhotoEvent> }> = ({ events }) => {

    return (
        <Grid container>
            {
                events.map(x =>
                    <Grid
                        size={{ xs: 12, sm: 6, md: 4, lg: 3, xl: 2 }}
                        key={`event-${x.id}`}>
                        <EventLink event={x} />
                    </Grid>
                )
            }
        </Grid>
    )
}

export default EventsList;
